export default __webpack_public_path__ + "static/media/whatsapp clone.47fd28f9.png";